import { Box, Button, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React, { Fragment, useEffect, useState } from 'react'
import SaveIcon from '@mui/icons-material/Save';
import CancelIcon from '@mui/icons-material/Cancel';
import EditRowPOS from './components/EditRowPOS';
import ReadOnlyRowPOS from './components/ReadOnlyRowPOS';
import { useValue } from '../../../context/ContextProvider';
import { EnviarProductosComprados } from '../../../actions/tienda';

const PosTabla = ({ currentUser, dispatch, prodSel, setProdSel, subtotal, dispTienda, setDispTienda, addPan, addGeneral, showAlerta }) => {
    const { state: { productos } } = useValue();
    const [editRowId, setEditRowId] = useState(null);

    const handleUpdate = (newRow) => {
        /*
        const productoEncontrado = productos.find((producto) => producto.nombreProducto == newRow.product);
        const oldData = prodSel.find((p) => newRow.id == p.id);
        const n = newRow.cantidad - oldData.cantidad;
        console.log({ newRow, productoEncontrado, oldData, n });

        if (productoEncontrado.type == 'Pan') {
            addPan(productoEncontrado, n);
        } else {
            const newProdSel = prodSel.map((p) => (
                p.id == newRow.id ? newRow : p
            ))
            setProdSel(newProdSel);
        }
        setEditRowId(0);
        */

        const productoEncontrado = productos.find((producto) => producto.product == newRow.product);
        const oldData = prodSel.find((p) => newRow.id == p.id);
        const n = newRow.cantidad - oldData.cantidad;
        //console.log({ newRow, productoEncontrado, oldData, n });

        if (productoEncontrado.type == 'Pan') {
            addPan(productoEncontrado, n);
        } else {
            /*
            const newProdSel = prodSel.map((p) => (
                p.id == newRow.id ? newRow : p
            ))
            setProdSel(newProdSel);
            */
           addGeneral(productoEncontrado, n);
        }
        setEditRowId(0);
       
    }

    const handleDelete = async (row) => {
        //console.log('Delete row:', row);
        let newProdSel = prodSel.filter((p) => row.id != p.id);
        //console.log({ newProdSel });
        newProdSel = newProdSel.map((p, i) => ({ ...p, id: i + 1 }));
        //console.log({ newProdSel });
        setProdSel(newProdSel);
    }


    //===============================================================================================================
    // Funcion para borrar la lista de producto sin enviar al servidor
    //===============================================================================================================
    const handleCancelClick = async (event) => {
        event.preventDefault();
        setProdSel([]);
    }
    //===============================================================================================================


    //===============================================================================================================
    // Funcion para actualizar lista de productos y enviar los datos al servidor
    //===============================================================================================================
    const handleSaveClick = async (event) => {
        event.preventDefault();

        //Se debe enviar la información de venta al servidor
        try {
            const resp = await EnviarProductosComprados(prodSel, currentUser, dispatch);
            //console.log({resp});    
        } catch (error) {
            console.log(error);
        }
        
        //Luego se actualizan los arrays locales en el servidor, para mantener la cantidad de productos aun disponibles en tienda
        let newDispTienda = dispTienda;
        prodSel.forEach((ps) => {
            newDispTienda = newDispTienda.map((dt) => {
                //console.log([ps.product, dt.product]);
                if (ps.product === dt.product) {
                    const tdisp = dt.totalDisponible - ps.cantidad;
                    //console.log('Coincidencia', dt.totalDisponible, ps.cantidad, tdisp);
                    return ({ ...dt, totalDisponible: (dt.totalDisponible - ps.cantidad) })
                } else {
                    return dt;
                }
            })
        })

        //Luego verifica si alguno de los items siguen o no disponibles en tienda para eliminarlos de la lista
        newDispTienda = newDispTienda.filter(ndt => ndt.totalDisponible != 0);
        setDispTienda(newDispTienda);
        //console.log({dispTienda, newDispTienda});

        //Aquí se puede informar mediante un dialogo que se ha ejecutado la venta y luego se debe borrar la tabla para una nueva venta
        setProdSel([]);
    }
    //===============================================================================================================

    function ccyFormat(num) {
        return `${num.toFixed(2)}`;
    }

    return (
        <Fragment>
            <Stack direction='column' bgcolor='white' height='100%' sx={{ justifyContent: 'space-between', alignItems: 'center' }}>
                <Box style={{ height: 600, maxWidth: '1000px', backgroundColor: 'white' }}>
                    <Typography variant="h5" component="h5" p={1} align='center'>
                        Detalle prodSel
                    </Typography>
                    <Box mt={6}>
                        <TableContainer>
                            <Table size='small'>
                                <TableHead>
                                    <TableRow>
                                        <TableCell align='left'>Item</TableCell>
                                        <TableCell align='left'>Cod Barras</TableCell>
                                        <TableCell align='left'>Producto</TableCell>
                                        <TableCell align='right'>Precio U</TableCell>
                                        <TableCell align='right'>Cant</TableCell>
                                        <TableCell align='right'>Total</TableCell>
                                        <TableCell align='left'>Controles</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {prodSel?.map((p, i) => (
                                        editRowId === p.id ?
                                            <EditRowPOS
                                                key={'erp_' + i}
                                                row={p}
                                                handleUpdate={handleUpdate}
                                                setEditRowId={setEditRowId}
                                                showAlerta={showAlerta}
                                            />
                                            : <ReadOnlyRowPOS
                                                key={'rorp_' + i}
                                                row={p}
                                                setProdSel={setProdSel}
                                                setEditRowId={setEditRowId}
                                                handleDelete={handleDelete}
                                            />

                                    ))}


                                    {prodSel?.length > 0 &&
                                        <Fragment>
                                            <TableRow hover={true}>
                                                <TableCell rowSpan={3} colSpan={3} style={{ borderBottom: "none", borderRight: "0px solid green" }}>  </TableCell>
                                                <TableCell colSpan={2}>Subtotal</TableCell>
                                                <TableCell align="right">{ccyFormat(subtotal)}</TableCell>
                                            </TableRow>
                                            <TableRow>
                                                <TableCell colSpan={1}>Descuento</TableCell>
                                                <TableCell align="right">{`${(0.0 * 100).toFixed(0)} %`}</TableCell>
                                                <TableCell align="right">{ccyFormat(0.00)}</TableCell>
                                            </TableRow>
                                            <TableRow sx={{ border: 0 }}>
                                                <TableCell colSpan={2} variant='head' sx={{ color: 'blue' }}>Total</TableCell>
                                                <TableCell align="right" variant='head' sx={{ color: 'blue' }}>{ccyFormat(subtotal)}</TableCell>
                                            </TableRow>
                                        </Fragment>
                                    }

                                </TableBody>
                            </Table>
                        </TableContainer>
                    </Box>
                </Box>

                {prodSel.length > 0 &&
                    <Box width='100%' sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', border: '1px solid lightgray', borderRadius: 1 }}>
                        <Box width={'40%'} m={2} maxWidth={'200px'}>
                            <Button variant='outlined' onClick={handleCancelClick} fullWidth startIcon={<CancelIcon />}>Borrar Todo</Button>
                        </Box>
                        <Box width={'40%'} m={2} maxWidth={'200px'}>
                            <Button variant='outlined' onClick={handleSaveClick} fullWidth startIcon={<SaveIcon />}>Guardar Todo</Button>
                        </Box>
                    </Box>
                }

            </Stack>
        </Fragment>
    )
}

export default PosTabla